import * as React from "react";

function IcSystemStatusFailFill16(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 16,
    height = 16,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemStatusFailFill16"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_554_19)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM6.20711 4.79289C5.81658 4.40237 5.18342 4.40237 4.79289 4.79289C4.40237 5.18342 4.40237 5.81658 4.79289 6.20711L6.58579 8L4.79289 9.79289C4.40237 10.1834 4.40237 10.8166 4.79289 11.2071C5.18342 11.5976 5.81658 11.5976 6.20711 11.2071L8 9.41421L9.79289 11.2071C10.1834 11.5976 10.8166 11.5976 11.2071 11.2071C11.5976 10.8166 11.5976 10.1834 11.2071 9.79289L9.41421 8L11.2071 6.20711C11.5976 5.81658 11.5976 5.18342 11.2071 4.79289C10.8166 4.40237 10.1834 4.40237 9.79289 4.79289L8 6.58579L6.20711 4.79289Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_554_19">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IcSystemStatusFailFill16;
